import { memo, useMemo } from "react";

const LOADING_MESSAGES = [
  "Crunching numbers…",
  "Fetching data…",
  "Warming up the charts…",
  "Querying the warehouse…",
  "Assembling pixels…",
  "Summoning metrics…",
  "Counting impressions…",
  "Connecting the dots…",
  "Calibrating axes…",
  "Preparing your dashboard…",
  "Loading…",
  "Almost there…",
  "Plotting the course…",
  "Wrangling data points…",
  "Thinking in charts…",
];

interface ChartPlaceholderProps {
  height?: number;
}

function ChartPlaceholder({ height = 400 }: ChartPlaceholderProps) {
  const message = useMemo(() => LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)], []);

  // Match the loaded ChartFrame structure: header (~40px) + chart body
  return (
    <div className="chart-frame">
      <div className="chart-frame__header">
        <h2>&nbsp;</h2>
      </div>
      <div className="chart-placeholder" style={{ height }}>
        <div className="chart-placeholder__label">{message}</div>
      </div>
    </div>
  );
}

export default memo(ChartPlaceholder);
